var UserModel = /** @class */ (function () {
    function UserModel() {
        this.email = "";
        this.passwordHash = "";
        this.firstName = "";
        this.lastName = "";
        this.fullName = "";
        this.isActive = false;
        this.twoFactorEnabled = false;
        this.twoFactorConfirmed = false;
        this.isManager = false;
        this.isDefault = false;
        this.managerId = 0;
        this.sequenceNumber = 0;
        this.userId = 0;
        this.jobDescriptionId = 0;
        this.branchId = 0;
        this.nationalId = 0;
        this.guid = "";
        this.ownDepartmentConfidentialityLevelId = 0;
        this.otherDepartmentConfidentialityLevelId = 0;
        this.annotationConfidentialityLevelId = 0;
        this.ownDepartmentImportanceLevel = 0;
        this.otherDepartmentImportanceLevel = 0;
        this.roleUsers = [];
        this.permissions = [];
        this.userPhoneNumbers = [];
    }
    return UserModel;
}());
export { UserModel };
var RoleUserModel = /** @class */ (function () {
    function RoleUserModel(user) {
        this.dbId = 0;
        this.roleId = 0;
        this.insertDate = new Date();
        this.updateDate = new Date();
        this.userId = user.userId;
        this.isDefault = user.roleUsers.length === 0;
    }
    return RoleUserModel;
}());
export { RoleUserModel };
var RoleDashboardModel = /** @class */ (function () {
    function RoleDashboardModel() {
    }
    return RoleDashboardModel;
}());
export { RoleDashboardModel };
